import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';
import '../styles/Home.css';

const Home = () => {
  return (
    <div className="home">
      <section className="hero">
        <div className="hero-content">
          <h1>Welcome to Kids Club Early Learning Center LLC</h1>
          <p>Nurturing young minds in Plant City, Florida</p>
          <div className="hero-buttons">
            <Link to="/schedule-tour" className="btn btn-primary">Schedule a Tour</Link>
            <Link to="/about" className="btn btn-secondary">Learn More</Link>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <h2>Why Choose Kids Club?</h2>
          <div className="features-grid">
            <div className="feature">
              <h3>Quality Education</h3>
              <p>Age-appropriate curriculum designed to foster learning and development</p>
            </div>
            <div className="feature">
              <h3>Experienced Staff</h3>
              <p>Qualified educators dedicated to your child's growth and success</p>
            </div>
            <div className="feature">
              <h3>Safe Environment</h3>
              <p>Secure, clean, and nurturing environment for children to thrive</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta">
        <div className="container">
          <h2>Ready to Get Started?</h2>
          <p>Contact us today to learn more about enrollment opportunities</p>
          <Link to="/contact-us" className="btn btn-primary">Contact Us</Link>
        </div>
      </section>
    </div>
  );
};

export default Home;